import Naluri from '~/common/api/naluri'
import {
  THOUGHT_JOURNAL_SET_READ_STATUS_BEGIN,
  THOUGHT_JOURNAL_SET_READ_STATUS_SUCCESS,
  THOUGHT_JOURNAL_SET_READ_STATUS_FAILURE,
  THOUGHT_JOURNAL_SET_READ_STATUS_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function setReadStatus(journalID) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: THOUGHT_JOURNAL_SET_READ_STATUS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = Naluri.post(`/api/expert/notification/mark/${journalID}?type=thought_journal&action=module`)
      doRequest.then(
        (res) => {
          dispatch({
            type: THOUGHT_JOURNAL_SET_READ_STATUS_SUCCESS,
            data: res,
            uuid: journalID
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: THOUGHT_JOURNAL_SET_READ_STATUS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSetReadStatusError() {
  return {
    type: THOUGHT_JOURNAL_SET_READ_STATUS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case THOUGHT_JOURNAL_SET_READ_STATUS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        setReadStatusPending: true,
        setReadStatusError: null,
      };

    case THOUGHT_JOURNAL_SET_READ_STATUS_SUCCESS:
      // The request is success

      const list = state.listing.withMutations(list =>
        list.update(
          list.findIndex(item => item.id === action.uuid),
          (item) => (item) ? Object.assign(item, {unread: 0}) : item
        ))

      return {
        ...state,
        listing: list,
        setReadStatusPending: false,
        setReadStatusError: null,
      };

    case THOUGHT_JOURNAL_SET_READ_STATUS_FAILURE:
      // The request is failed
      return {
        ...state,
        setReadStatusPending: false,
        setReadStatusError: action.data.error,
      };

    case THOUGHT_JOURNAL_SET_READ_STATUS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        setReadStatusError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/thought-journal/redux/setReadStatus.js